export enum RoutePaths {
  Home = '/',
  Search = '/search/:query?',
  Media = '/media/:id?',
}
